export default "__VITE_ASSET__39893f87__"